import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
const secondaryStats = [{
  value: '2',
  label: 'Offices open — Bengaluru & Chennai'
}, {
  value: '7',
  label: 'Cities planned by 2028'
}, {
  value: 'Fee-only',
  label: 'No commissions, ever'
}];
export function TrustBar() {
  return <section className="border-b border-line bg-cream" aria-label="Firm at a glance" data-id="element-151" data-mp="1fe1ytvcs5vo5">
      <div className="mx-auto w-full max-w-shell px-5 py-10 sm:px-8 sm:py-12" data-id="element-152" data-mp="11notm0r9wv2i">
        <Reveal className="grid gap-8 lg:grid-cols-12 lg:items-center" data-id="element-153" data-mp="16f6s8i5tqjkb">
          <div className="lg:col-span-4" data-id="element-154" data-mp="16ghx6lb09xd0">
            <p className="font-serif text-[2.75rem] leading-none text-charcoal sm:text-[3.25rem]" data-id="element-155" data-mp="rqk53u9ygnij">
              15<span className="align-top text-[1.5rem] text-gold" data-id="element-156" data-mp="wpwzr172iyvo">+</span> years
            </p>
            <p className="mt-2 text-sm text-charcoal-600" data-id="element-157" data-mp="ioubqiwijei4">
              Our founder&apos;s experience across public and private markets, before a single client
              was taken on
            </p>
          </div>

          <dl className="grid grid-cols-3 gap-4 border-line lg:col-span-5 lg:border-l lg:pl-10" data-id="element-158" data-mp="3dtupqfhbdk1m">
            {secondaryStats.map(stat => <div key={stat.label} data-id="element-159" data-mp="3ntbpkg9vx3po">
                <dt className="sr-only" data-id="element-160" data-mp="3nsae4aoyif7f">{stat.label}</dt>
                <dd className="font-serif text-2xl text-charcoal" data-id="element-161" data-mp="3iu8wlu76iny2">{stat.value}</dd>
                <p className="mt-1 text-xs leading-snug text-charcoal-400" data-id="element-162" data-mp="3is5uwcwnz6di">{stat.label}</p>
              </div>)}
          </dl>

          <div className="lg:col-span-3 lg:flex lg:justify-end" data-id="element-163" data-mp="2q639j0snkmv2">
            <div className="inline-flex items-start gap-2 rounded-sm border border-line bg-paper px-3 py-2.5" data-id="element-164" data-mp="2q3qizz8tx46e">
              <ShieldCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-165" data-mp="303r861tdqeii" />
              <span className="text-[0.72rem] leading-snug tracking-wide text-charcoal-600" data-id="element-166" data-mp="2ce6mvc9r7562">
                SEBI Registered Investment Adviser
                <span className="mt-0.5 block font-medium text-charcoal" data-id="element-167" data-mp="27e21b7tznk8z">INA200016412</span>
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}